export default "__VITE_ASSET__Do5ckdPT__"